export default __webpack_public_path__ + "static/media/education_hat.09cec365.svg";